module.exports = {"370114001":"明水街道","370114002":"双山街道","370114003":"枣园街道","370114004":"龙山街道","370114005":"埠村街道","370114006":"圣井街道","370114007":"普集街道","370114008":"绣惠街道","370114009":"相公庄街道","370114010":"文祖街道","370114011":"官庄街道","370114012":"高官寨街道","370114013":"白云湖街道","370114014":"宁家埠街道","370114015":"曹范街道","370114100":"刁镇","370114101":"垛庄镇","370114102":"黄河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370114.json
// module id = 1357
// module chunks = 0